/**
 * Created by jv on 06/01/2017.
 */
const LanguageManager = require("Sources/services/languagemanager");
const moment = require("moment");
const utils = require("Sources/utils/utils");
const Order = require("Sources/models/order");
const Token = require("Sources/models/token");
const Contact = require("Sources/models/contact");
const Customer = require("Sources/models/admin/customer");

module.exports = class Subscription
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.key = options.key;
    this.number = options.number;

    this.type = options.type;
    this.city = options.city;
    this.organisation = options.organisation;
    this.status = options.status;
    this.paymentStatus = options["payment-status"];

    this.extendable = options["can-be-extended"];
    this.prolong = options.prolong;

    this.groupPurchaseKey = options["group-purchase-key"];

    this.purchaseOrderRequired = options["bestelbon-required"];
    this.vatNumber = options["vat"];
    this.companyNumber = options["company-number"];

    this.validStart = options["valid-from"];
    this.validEnd = options["valid-until"];

    this.grace = utils.isDefined(options.grace) ? options.grace : 0;
    this.correction = utils.isDefined(options.correction) ? options.correction : 0;

    this.tokens = utils.isArray(options.tokens) ? options.tokens : [];
    this.contacts = utils.isArray(options.contacts) ? options.contacts : [];
    this.linkedProfiles = utils.isArray(options["linked-profiles"]) ? options["linked-profiles"] : [];
    this.orders = utils.isArray(options.orders) ? options.orders : [];

    if(utils.isDefined(options.customer))
    {
      this.customer = options.customer;
    }
  }

  set customer(customer)
  {
    this._customer = new Customer(customer);
  }

  get customer()
  {
    return this._customer;
  }

  get type()
  {
    switch(this._type)
    {
      case "avi":
      case "bibnet_avi":
        return "subscription_details.types.avi";
      case "picture":
      case "bibnet_picturebooks":
        return "subscription_details.types.picture";
      default:
        return null;
    }
  }

  get shortType()
  {
    switch(this._type)
    {
      case "avi":
        return "subscription_details.types.avi.short";
      case "bibnet_avi":
        return "subscription_details.types.avi_bib.short";
      case "picture":
        return "subscription_details.types.picture.short";
      case "bibnet_picturebooks":
        return "subscription_details.types.picture_bib.short";
      default:
        return null;
    }
  }

  set type(type)
  {
    this._type = type;
  }

  set validStart(date)
  {
    this._validStart = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get validStart()
  {
    return utils.isMomentObject(this._validStart) ? this._validStart.format("DD-MM-YYYY") : null;
  }

  set validEnd(date)
  {
    this._validEnd = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get validEnd()
  {
    return utils.isMomentObject(this._validEnd) ? this._validEnd.format("DD-MM-YYYY") : null;
  }

  get validEndGrace()
  {
    var grace = "";

    if(this.grace > 0)
    {
      grace = " +" + (this.correction + this.grace) + " " + LanguageManager.getValueForKey("products.grace.days");
    }

    return utils.isMomentObject(this._validEnd) ? this._validEnd.format("DD-MM-YYYY") + grace : null;
  }

  isValidWithGraceAndCorrection()
  {
    var validUntilWithGraceAndCorrection = moment(this._validEnd).add(this.grace + this.correction, "days");

    return !validUntilWithGraceAndCorrection.isBefore(moment());
  }


  get isGroupPurchase()
  {
    return utils.isNotNull(this.groupPurchaseKey);
  }

  set tokens(tokens)
  {
    this._tokens = [];

    if(utils.isArray(tokens))
    {
      for(var i = 0; i < tokens.length; i++)
      {
        this._tokens.push(new Token(tokens[i]));
      }
    }
  }

  get tokens()
  {
    return this._tokens;
  }

  set contacts(contacts)
  {
    this._contacts = [];

    if(utils.isArray(contacts))
    {
      for(var i = 0; i < contacts.length; i++)
      {
        this.addContact(contacts[i]);
      }
    }
  }

  get contacts()
  {
    return this._contacts;
  }

  addContact(contact)
  {
    this._contacts.push(new Contact(contact));
  }

  setContactForType(type, contact)
  {
    this.removeContactForType(type);
    this.addContact(contact);
  }

  removeContactForType(type)
  {
    for(var i = 0; i < this.contacts.length; i++)
    {
      if(this.contacts[i].type === type)
      {
        this.contacts.splice(i, 1);
      }
    }
  }

  getContactForType(type)
  {
    for(var i = 0; i < this.contacts.length; i++)
    {
      if(this.contacts[i].type === type)
      {
        return this.contacts[i];
      }
    }

    return null;
  }

  getTokenForKey(tokenKey)
  {
    for(var i = 0; i < this.tokens.length; i++)
    {
      if(tokenKey === this.tokens[i].key)
      {
        return this.tokens[i];
      }
    }

    return null;
  }

  set linkedProfiles(linkedProfiles)
  {
    this._linkedProfiles = [];

    if(utils.isArray(linkedProfiles))
    {
      for(var i = 0; i < linkedProfiles.length; i++)
      {
        var tmpLinkedProfile = linkedProfiles[i];

        this._linkedProfiles.push({
          profileKey: tmpLinkedProfile["profile-key"],
          incomplete: tmpLinkedProfile.incomplete,
          email: tmpLinkedProfile.email,
          firstname: tmpLinkedProfile.meta.firstname,
          lastname: tmpLinkedProfile.meta.lastname,
          displayName: tmpLinkedProfile["display-name"],
          locale: tmpLinkedProfile.locale,
          subscriptionProfileType: tmpLinkedProfile["subscription-profile-type"]
        });
      }
    }
  }

  get linkedProfiles()
  {
    return this._linkedProfiles;
  }

  set orders(orders)
  {
    this._orders = [];

    if(utils.isArray(orders))
    {
      for(var i = 0; i < orders.length; i++)
      {
        this._orders.push(new Order(orders[i]));
      }
    }
  }

  get orders()
  {
    return this._orders;
  }

  get readableStatus()
  {
    switch(this.status)
    {
      case "valid":
        return "subscription_details.status.valid";
      case "expired":
        return "subscription_details.status.expired";
      case "grace":
        return "subscription_details.status.grace";
      case "unknown":
      default:
        return "subscription_details.status.unknown";
    }
  }

  get readablePaymentStatus()
  {
    switch(this.paymentStatus)
    {
      case "payed":
      case "complete":
        return "subscription_details.payment_status.payed";
      case "awaiting_approval":
      case "awaiting_invoice":
        return "subscription_details.payment_status.processing";
      case "awaiting_payment":
        return "subscription_details.payment_status.processing_payment";
      case "awaiting_delivery":
        return "subscription_details.payment_status.processing_delivery";
      case "cancelled":
      case "awaiting_cancellation":
        return "subscription_details.payment_status.cancelled";
      default:
        // return this.paymentStatus;
        return "subscription_details.payment_status.unknown";
    }
  }

  isGroupOrderReadable()
  {
    return this.isGroupPurchase ? "globals.options.yes" : "globals.options.no";
  }

  get readableIsGroupPurchase()
  {
    return this.isGroupPurchase ? "globals.options.yes" : "globals.options.no";
  }

  get readableVatNumber()
  {
    return utils.isNullOrEmpty(this.vatNumber) ? "-" : this.vatNumber;
  }

  get readableCompanyNumber()
  {
    return utils.isNullOrEmpty(this.companyNumber) ? "-" : this.companyNumber;
  }

  get readablePurchaseOrderRequired()
  {
    return this.purchaseOrderRequired ? "globals.options.yes" : "globals.options.no";
  }
};



// WEBPACK FOOTER //
// ./app/js/models/subscription.js